import { createAction } from "@reduxjs/toolkit";

export const combinedActions = <T=void, S=void, F=string>(prefix: string) => {
  return {
    trigger: createAction<T>(prefix + "/TRIGGER"),
    success: createAction<S>(prefix + "/SUCCESS"),
    failure: createAction<F>(prefix + "/FAILURE"),
  };
};
